import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette, TextField, Typography } from '@nutrien/cxp-components';
import React from 'react';

interface Props {
  updateEmail: (email: string) => void;
}

const useStyles = makeStyles({
  nextBtn: { width: '100%' },
  checkBoxText: {
    color: MaterialPalette.text.primary,
    padding: '10px 0px 38px 0px',
  },
  alignCenter: {
    textAlign: 'center',
  },
  checkBox: {
    margin: '10px 0px 38px -10px',
  },

  space: {
    padding: '15px 0px 10px 0px',
  },
});

const LoginFlowUsername = ({ updateEmail }: Props) => {
  const classes = useStyles();
  const handleChange = (event: React.FocusEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    localStorage.setItem('userName', value);
    updateEmail(value);
  };

  return (
    <>
      <Typography align="center" fontWeight={700} variant="h6">
        Sign in with username and password
      </Typography>
      <Grid item container xs={12} justifyContent="center" className={classes.space}>
        <TextField
          label="User name"
          noMinHeight
          onChange={handleChange}
          size="small"
          inputProps={{ 'data-testid': 'email-input' }}
        />
      </Grid>
    </>
  );
};

export default LoginFlowUsername;
